{
  "production": false,
  "baseApiUrl": "https://api-streapp.seriouscode-test.nl/",
  "authApiUrl": "https://identity-api-streapp.seriouscode-test.nl",
  "hostUrl": "http://localhost:4200/",
  "functionsUrl": "https://api-streapp.seriouscode-test.nl",
  "versionCheckURL": "http://localhost:4200/version.json",
  "shopUrl": "https://shop-streapp.seriouscode-test.nl",
  "azureKey": "SROjwQ2cy75Xj0GHK5hcjAoPMSAGa7s3ozx1C9mm0RQ"
}
